import { render, staticRenderFns } from "./select-specialization.vue?vue&type=template&id=18b8c23c"
import script from "./select-specialization.vue?vue&type=script&lang=js"
export * from "./select-specialization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports